import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { AlertMessage } from "@shared/services/alert-message/alert-message.model";

@Component({
	selector: "app-informative-dialog",
	templateUrl: "./informative-dialog.component.html",
	styleUrl: "./informative-dialog.component.scss",
	standalone: false
})
export class InformativeDialogComponent {
	constructor(
		public dialogRef: MatDialogRef<InformativeDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: AlertMessage
	) { }

	close() {
		this.dialogRef.close();
	}

	/* 	ok() {
			this.dialogRef.close("ok");
		} */
}